export class BaseAddresViewModel
{
    name:string;
    address:string;
    city:string;
    zip:string;
    state:string;
    phone:string;
    constructor() {
        this.name="";
        this.address="";
        this.state="";
        this.city="";
        this.zip="";
        this.phone="";
    }    
}


// WEBPACK FOOTER //
// ./src/app/ViewModels/TowLocateViewModels/BaseAddress.ts